import { AuthService } from '@core/services/auth.service';
import { DataService } from '@core/services/data.service';
import { NotificationService } from '@core/services/notification.service';
import { QuestionService } from '../../../data/question.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { CommonModule, KeyValuePipe, NgFor, NgIf } from '@angular/common';
import { ButtonComponent } from '@shared/components/button/button.component';
import { PdfViewBoxComponent } from '@shared/components/pdf-view-box/pdf-view-box.component';
import { Rol } from '@core/models/user';
import { ButtonService } from '../../../data/btn.services';
import { FinapiService } from '../../../data/finapi.service';
import { CheckBoxComponent } from '@shared/components/checkbox/checkbox.component';
import { ContentCardComponent } from '@shared/components/content-card/content-card.component';
import { InputtextComponent } from '@shared/components/inputtext/inputtext.component';
import { SeparatorComponent } from '@shared/components/separator/separator.component';
import { TranslationDirective } from '@shared/components/translata-modal/translation.directive';
import { DOKUMENT_NAME } from '@core/models/dokument-names';
import { QuestionTemplate } from '../question-template';
import { CdkTableModule } from '@angular/cdk/table';
import { AppDialogRef, DialogService } from '@core/services/dialog.service';
import { AccordionComponent } from '@shared/components/expansion/accordion.component';
import { ExpansionPanelHeaderComponent } from '@shared/components/expansion/expansion-panel-header.component';
import { ExpansionPanelComponent } from '@shared/components/expansion/expansion-panel.component';
import { PanelTitleComponent } from '@shared/components/expansion/panel-title.component';
export interface Dokument {
  name: string;
  position: number;
}

const AGBS_DATA: Dokument[] = [
  { name: DOKUMENT_NAME.AGB, position: 1 },
  { name: DOKUMENT_NAME.SB_ONLINE_BANKING, position: 2 },
  { name: DOKUMENT_NAME.SB_LASTSCHRIFT, position: 3 },
  { name: DOKUMENT_NAME.SB_UEBERWEISUNG, position: 4 },
  { name: DOKUMENT_NAME.SB_ECHTZEIT, position: 5 },
  { name: DOKUMENT_NAME.SB_ECHTZEIT_SAMMEL, position: 6 },
  { name: DOKUMENT_NAME.SB_GIROCARD, position: 7 },
  { name: DOKUMENT_NAME.SB_POSTFACH, position: 8 },
];

const DATENSCHUTZ_DATA: Dokument[] = [{ name: DOKUMENT_NAME.DATENSCHUTZ, position: 9 }];

const INFOEINLEGER_DATA: Dokument[] = [{ name: DOKUMENT_NAME.INFO_EINLEGER, position: 11 }];

const EINWILLIGUNG_DATA: Dokument[] = [{ name: DOKUMENT_NAME.EINWILLIGUNG, position: 13 }];
@Component({
  selector: 'app-blanko-dokumente',
  templateUrl: './blanko-dokumente.component.html',
  styleUrls: ['./blanko-dokumente.component.scss'],
  imports: [AccordionComponent, ExpansionPanelComponent, ExpansionPanelHeaderComponent, PanelTitleComponent, CdkTableModule, 
    CommonModule,
    TranslationDirective,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    ButtonComponent,
    NgFor,
    KeyValuePipe,
    ContentCardComponent,
    SeparatorComponent,
    CheckBoxComponent,
    InputtextComponent,
  ],
})
export class BlankoDokumenteComponent extends QuestionTemplate implements OnInit {
  private dialogRef?: AppDialogRef;
  isAdmin: Boolean;
  juriPerson: boolean = false;
  agbDataSource = AGBS_DATA;
  datenschutzDataSource = DATENSCHUTZ_DATA;
  einwilligungDataSource = EINWILLIGUNG_DATA;
  infoEinlegerDataSource = INFOEINLEGER_DATA;
  displayedColumns: string[] = ['name', 'download'];
  constructor(
    auth: AuthService,
    questionService: QuestionService,
    route: ActivatedRoute,
    public btnService: ButtonService,
    private dataService: DataService,
    private notificationService: NotificationService,
    private tranlate: TranslateService,
    private dialog: DialogService,
    private finapiService: FinapiService
  ) {
    super(auth, questionService, route);
    this.questionName = 'blanko-dokumente';
  }

  /**
   * Init variables und FormGroup machen
   */
  override ngOnInit() {
    super.ngOnInit();
    this.isAdmin = this.auth.user.rol == Rol.admin || this.auth.user.rol == Rol.adminBB;
    this.answerFormGroup = new FormGroup({
      hinweise: new FormControl(null, [Validators.requiredTrue]),
      nurDeSteuerpflicht: new FormControl(null, [Validators.requiredTrue]),
      usSteuerpflicht: new FormControl(null),
      agbs: new FormControl(null, [Validators.requiredTrue]),
      datenschutz: new FormControl(null, [Validators.requiredTrue]),

      //einwilligungKundenansprache: new FormControl(false),
      geschaeftsFinanzdaten: new FormControl(false, [Validators.requiredTrue]),
      zahlungsdaten: new FormControl(false, [Validators.requiredTrue]),
      nutzungsdaten: new FormControl(false, [Validators.requiredTrue]),

      offentlichesAmt: new FormControl(null, [Validators.required]),
      offentlichesAmtField: new FormControl({ value: '', disabled: true }, null),
      einlagensicherung: new FormControl(null, [Validators.requiredTrue]),
      schufaZustimmung: new FormControl(null, [Validators.requiredTrue]),
      loaddatafromfinapi: new FormControl(false, [Validators.requiredTrue]),
    });

    if (!this.auth.isJurPerson()) {
      this.answerFormGroup.controls['usSteuerpflicht'].setValue(false);
      this.answerFormGroup.controls['usSteuerpflicht'].setValidators([Validators.requiredTrue]);
      this.answerFormGroup.controls['usSteuerpflicht'].updateValueAndValidity();
    }
    this.loadValues();
    this.juriPerson = this.auth.isJurPerson();

    this.finapiService.getProccessToken().subscribe((res) => {
      this.finapiService.getAccessToken(res?.processToken).subscribe(() => {
        {
          this.answerFormGroup.controls['loaddatafromfinapi'].setValue(true);
        }
      });
    });
  }

  consentOptionsForDataCategories = [
    {
      key: 'kundenansprache',
      id: 'einwilligung-0',
      level: 2,
      title: 'RECHTLICHES.einwilligungKundenansprache_TITLE',
      sub: 'RECHTLICHES.einwilligungKundenansprache_SUB_TITLE',
      control: 'einwilligungKundenansprache',
      checkboxText: 'RECHTLICHES.einwilligungKundenansprache_CHECKBOX_TEXT',
      showCheckbox: false,
    },
    {
      key: 'geschaeftsFinanzdaten',
      id: 'einwilligung-1',
      level: 4,
      title: 'RECHTLICHES.einwilligunggeschaeftsFinanzdaten_TITLE',
      sub: 'RECHTLICHES.einwilligunggeschaeftsFinanzdaten_SUB_TITLE',
      control: 'geschaeftsFinanzdaten',
      checkboxText: 'RECHTLICHES.einwilligunggeschaeftsFinanzdaten_CHECKBOX_TEXT',
      showCheckbox: true,
    },
    {
      key: 'zahlungsdaten',
      id: 'einwilligung-2',
      level: 4,
      title: 'RECHTLICHES.einwilligungzahlungsdaten_TITLE',
      sub: 'RECHTLICHES.einwilligungzahlungsdaten_SUB_TITLE',
      control: 'zahlungsdaten',
      checkboxText: 'RECHTLICHES.einwilligungzahlungsdaten_CHECKBOX_TEXT',
      showCheckbox: true,
    },
    {
      key: 'nutzungsdaten',
      id: 'einwilligung-3',
      level: 4,
      title: 'RECHTLICHES.einwilligungnutzungsdaten_TITLE',
      sub: 'RECHTLICHES.einwilligungnutzungsdaten_SUB_TITLE',
      control: 'nutzungsdaten',
      checkboxText: 'RECHTLICHES.einwilligungnutzungsdaten_CHECKBOX_TEXT',
      showCheckbox: true,
    },
  ];

  trackByConsentCategoryId(_index: number, item: { key: string }) {
    return item.key;
  }

  openRechtlichesDocument(documentNr: number) {
    this.dataService.getRechtlichesDocument(documentNr).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      this.dialogRef = this.dialog.open(PdfViewBoxComponent, {
        data: { pdfSrc: url },
      });

      this.dialogRef.afterClosed().subscribe(() => {});
    });
  }

  adminCheckAll() {
    const controls = this.answerFormGroup.controls;
    controls['hinweise']?.setValue(true);
    controls['nurDeSteuerpflicht']?.setValue(true);
    controls['usSteuerpflicht']?.setValue(true);
    controls['agbs']?.setValue(true);
    controls['datenschutz']?.setValue(true);
    controls['offentlichesAmt']?.setValue(false);
    controls['einlagensicherung']?.setValue(true);
    controls['schufaZustimmung']?.setValue(true);
    controls['geschaeftsFinanzdaten']?.setValue(true);
    controls['zahlungsdaten']?.setValue(true);
    controls['nutzungsdaten']?.setValue(true);
  }

  radioPepValidate() {
    const offentlichesAmt = this.answerFormGroup.controls['offentlichesAmt'];
    const offentlichesAmtField = this.answerFormGroup.controls['offentlichesAmtField'];

    if (offentlichesAmt.value === 'true') {
      offentlichesAmtField.enable();
      offentlichesAmtField.setValidators([Validators.required, Validators.minLength(1)]);
    } else {
      offentlichesAmtField.disable();
      offentlichesAmtField.clearValidators();
      offentlichesAmtField.setValue('');
    }

    offentlichesAmtField.updateValueAndValidity();
  }

  getControlTranslationKey(controlKey: string): string {
    switch (controlKey) {
      case 'hinweise':
        return 'RECHTLICHES.RECHTLICHE_TITLE';
      case 'nurDeSteuerpflicht':
      case 'usSteuerpflicht':
        return 'RECHTLICHES.SELBSTAUSKUNFT_TITLE';
      case 'agbs':
        return 'RECHTLICHES.ALLGEMEINE_TITLE';
      case 'datenschutz':
        return 'RECHTLICHES.DATENSCHUTZWEISE_TITLE';
      case 'offentlichesAmt':
        return 'RECHTLICHES.ERKLAERUNG_TITLE';
      case 'einlagensicherung':
        return 'RECHTLICHES.HINWEIS_TITLE';
      case 'schufaZustimmung':
        return 'RECHTLICHES.SCHUFA_TITLE';

      case 'geschaeftsFinanzdaten':
        return 'RECHTLICHES.einwilligunggeschaeftsFinanzdaten_TITLE';
      case 'zahlungsdaten':
        return 'RECHTLICHES.einwilligungzahlungsdaten_TITLE';
      case 'nutzungsdaten':
        return 'RECHTLICHES.einwilligungnutzungsdaten_TITLE';
      default:
        return '';
    }
  }
}
